// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"a4b7062c","706":"25516be2"}[chunkId] + ".chunk.js";
};